import React from 'react'

const Export = () => {
  return (
    <div className='MainContentMargin'>
      <div className="col-lg-12 TabulerReportMainDiv">
          <div className="card-body p-0">
            <div style={{ height: 780, width: "100%", padding:"15px" }}>
              <div className="siteformContainer"  style={{height:"80vh"}}>
                  <div className="site-form" style={{ display: "flex", flexDirection: "column" }}>
                    <div className="inputMainContainer w40dot75rem mb-5">
                          <div className="inputTypeLabelContainer">
                          <label className='formFieldLabels'>Select Entity</label>
                            <select className="inputType ArrowSelectClass">
                              <option key="0" disabled={false} value="0" id="0">Select Entity*</option>
                              <option>Site</option>
                              <option>Interface</option>
                              <option>Devices</option>
                              <option>Users</option>
                            </select>
                          </div>
                    </div>

                    <h5 style={{textAlign:"left"}}>Select fields <snap>(25)</snap></h5>
                    <div className="CameraFilterList" style={{width:"30%"}}> 
                      <div style={{border:"1px solid", padding:"10px"}}>
                          <div className="OneList">
                              <p className="ListofText">
                                  <span>Username</span> 
                              </p>
                              <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                                        <input type="checkbox" checked={true}/>
                                </div>
                              </div>
                          </div> 
                          <div className="OneList">
                              <p className="ListofText">
                                  <span>Email ID</span> 
                              </p>
                              <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                                        <input type="checkbox" checked={true}/>
                                </div>
                              </div>
                          </div>  
                          <div className="OneList">
                              <p className="ListofText">
                                  <span>Address</span> 
                              </p>
                              <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                                        <input type="checkbox" checked={true}/>
                                </div>
                              </div>
                          </div> 
                          <div className="OneList">
                              <p className="ListofText">
                                  <span>Address 1</span> 
                              </p>
                              <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                                        <input type="checkbox" checked={true}/>
                                </div>
                              </div>
                          </div> 
                          <div className="OneList">
                              <p className="ListofText">
                                  <span>Mobile User</span> 
                              </p>
                              <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                                        <input type="checkbox" checked={true}/>
                                </div>
                              </div>
                          </div> 
                          </div>        
                    </div>


                    <div style={{ textAlign: "center" }}>
                        <button className="DataAccessEdit" style={{ width: "180px" }} >
                            <span className="ViewUpdate">Export Details</span>
                        </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  )
}

export default Export